waitFor_jQuery(function () {

var ColorCompare = (function(){

  var config = {
    scope: {colors: [], name: "Compare Colors"}
  };
    
  var saveScopeToDB = function(refresh){
    if(config.customer != false){
      var data = {
        customer: config.customer,
        data: JSON.stringify(config.scope)
      };
      $.post('https://compare-colors.herokuapp.com/save.json', data, function(r){
        if(refresh){
      	  location.reload();
        };
      });
    }else{
      console.log("checking");
      var scope = JSON.stringify(config.scope);
      Cookies.set('cc_db', scope, 2);
      if(refresh){
        location.reload();
      };
    };
  };
    
  var initDB = function(callback){

    if(config.customer != false){
      $.getJSON('https://compare-colors.herokuapp.com/load.json?customer=' + config.customer, function(response){
        config.scope = response;

        if(Cookies.get('cc_db')) {
          var old_data = JSON.parse(Cookies.get('cc_db'))
          if (old_data && old_data.colors && old_data.colors.length > 0) {
            var new_data = $.merge(response.colors, old_data.colors)
            config.scope.color = new_data
            $.removeCookie('cc_db', { path: '/' });
            saveScopeToDB(true);
          }
        }

      	callback();
      });
    }else{
      var _db = Cookies.get('cc_db');
      console.log(_db);
      if(_db){
        config.scope = JSON.parse(_db);
      }else{
        var empty = JSON.stringify(config.scope);
        Cookies.set('cc_db', empty, 2);
      };
    };
  };
    
  var loadColors = function(){
    var markup =
      '<ul class="cc-row" id="colors">' +
        '<% for(var i in this.colors) { %>' +
          '<li class="cc-color" data-id="<% this.colors[i].id %>">' +
            '<div class="sort-action" style="display: none;"><svg width=11px height=16px viewBox="0 0 11 16" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink>\n' +
      '<title>grab-handle-icons-selection copy 4</title>\n' +
      '<g id=Inner-pages stroke=none stroke-width=1 fill=none fill-rule=evenodd>\n' +
      '<g id=Compare-mobile transform="translate(-22.000000, -928.000000)">\n' +
      '<image id=grab-handle-icons-selection-copy-4 x=22 y=928 width=10.7234043 height=16 xlink:href=data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAABeCAYAAACU98wgAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAP6ADAAQAAAABAAAAXgAAAAA7t5b1AAADJElEQVR4Ae1csW7CMBB1q4oBsSHBxF8w8/HM/AUTSGyIgaXloQZFbup3fomR4pyXJMT37t5d7Ni8lo/vRwsTbZ8T5f2k7eSnWn2vvFd+ghnwx36CRX9S/lKIn8/ncDweA4632+0JMZ/Pw2q1CpvN5nlUcJnN0H4/clZ41+s1HA6HcDqdknGu1+uw3W7DYrFI9rPeLOXXTP5yuYT9fh/u97sp5tlsFna7XVgul6b+/3Uq6dc04SHzOcRBBEmCDWzVVtqviTwedWvF20RhA1u1lfZLyWOSYWM8RQ62wMht7/BLyWNW79sUDMUmjpNhUPJK1eIgFAzFJtcvJd+8x2PgnGsFQ7GJY2IYlHwMWNM1JY+VW9+mYCg2cZwMg5LHkrVvUzAUmzhOhkHJY63etykYik0cJ8Og5JE9rNXVBltWgS7sd/il5BEYNilYq+c22MBWbaX9mshjd4ZNSk4Cmo1Nn51dab/mXR2qV2pryZ6MUn6zyDdBYvWFpSOOzUICrxWMU0wyyhhvsFPHof1K5FMBjumeacyPiVBOrE4+J1s19fXK11TNHC5e+Zxs1dTXK19TNXO4TLryLlRaH5VSuyvmv5Rf88ampGCYIl/Sr2nMI/MuVKZK1HHPhUoXKvPFTiYydjxofz5iGHTMv0Mw/BP144N3+KXkm+/ougK0fqZgKDZxPAyDko8Ba7qm5JnYZ0mGgqHYxLEwDEp+iK+hFQzFJibPMCh5JvbFDruuFQzFJvbNMCh5ZM+FShcq7UqtC5W1/O1tezIZWjBsY6fOh/Zr3s+nghrrPTrbj5WYJW4nb8lSjX288jVW1cLJK2/JUo19vPI1VtXCadKVd6HS8oigTynBkPkv5de8sSkpGKbIl/RrGvMuVBr/h7ZdRRcqXah0obI9Iui5C5U0RekOLlQm8kNfdUzsS2C/bikYis3L4e8Jw6DkmdgXO+y6VjAUm9g3w6DkmdgXO+y6VjAUm9g3w6DkkT0XKl2odKGS/oAIhklVPxLUnkyGFgzb2Knzof2a9/OpoMZ6j872YyVmidvJW7JUYx+vfI1VtXDyyluyVGOfSVf+B4Rs2pH/qJxxAAAAAElFTkSuQmCC></image>\n' +
      '</g>\n' +
      '</g>\n' +
      '</svg></div>' +
            '<div><img src="<% this.colors[i].image %>" /></div>' +
            '<div class="info">' +
              '<p class="title"><a href="/products/<% this.colors[i].handle %>"><% this.colors[i].title %></a></p>' +
              '<p class="actions">' +
                '<span><% this.colors[i].price %></span>  ' +
                '<a href="#" data-id="<% this.colors[i].id %>" class="cc-add">Add to cart</a> ' +
                '<a href="#" data-id="<% this.colors[i].id %>" class="cc-delete">x</a>' +
              '</p>' +
            '</div>' +
          '</li>' +
        '<% } %>' +
      '</ul>';
    var render = templateEngine(markup, {
      colors: config.scope.colors
    });
    $('#cc-container').html(render);
  };
    
  var loadSetup = function(){
    // $('.cc-loading').hide();
    // $("#cc-heading").html(config.scope.name);
    // $('#cc-breadcrumbs').show();
    if(config.scope.colors.length > 0){
      loadColors();
      $('#cc-breadcrumbs').show();
      $("#cc-footer").show();
      $(".cc-opt-2").show();
    }else{
      var render = '<h4 class="no-lists">You have no colors saved yet.</h4>';
      var render2 = '<a id="get-browsing" class="cc-opt-2 btn button button--primary Button--custom text-center" href="/collections/hand-dyed-yarns">\
Get Browsing!\
</a>';

      $('#cc-container').html(render);
      $('#cc-container2').html(render2);
      $(".cc-opt-1").show();
      var render_2 = 'Add More Colors'
      $('#get-browsing').html(render_2);
    };
  };
  
  var loadColSetup = function(){
    $('.cc-pick-color').css('display', 'block'); // show 'select to compare' button
    if(config.scope.colors.length > 0){
      $(".cc-go-to").show();
    };
    $.each(config.scope.colors, function(i,e){
      $(".cc-pick-color > input[data-id='"+ e.id +"']").prop("checked", true);
    });
  };
  
  var popup = function($el){
    var $popup = $($el.data('popup'));
    $popup.fadeIn();
    $popup.find('.cc-popup-close, .cc-popup-close-b').on('click', function(e){
      e.preventDefault();
      $popup.fadeOut();
    });
  };
  
  var renameList = function(name){
    config.scope.name = name;
    saveScopeToDB(true);
  };
  
  var destroyColor = function($el){
  	var result = $.grep(config.scope.colors, function(e){ return e.id != $el.data('id'); });
    config.scope.colors = result;
    saveScopeToDB(true);
  };
  
  var destroyMultipleColors = function($els){
    var toDel = [];
    $els.each(function(){
      toDel.push($(this).data('id'));
    });
  	var result = $.grep(config.scope.colors, function(e){ 
      return toDel.indexOf(e.id) == -1;
    });
    config.scope.colors = result;
    saveScopeToDB(true);
  };
  
  var addColorToList = function($el){
    if($el.is(':checked')){
      console.log(config.scope.colors.length);
      if(config.scope.colors.length == 0 && config.customer == false){
        console.log(122);
        $("#login-msg").fadeIn();
        $("#login-msg").find(".cc-popup-close-b").click(function(){
          $("#login-msg").fadeOut(200);
          $("#was-added").html('<b>' + $el.data('title') + '</b>' + ' was added to your Color list');
          $("#added-to-list").fadeIn(200, function(){
            setTimeout(function(){ $("#added-to-list").fadeOut(200) }, 1500);
          });
        });
      };
      $(".cc-go-to").show();
      config.scope.colors.push({
        id: $el.data('id'),
        title: $el.data('title'),
        image: $el.data('image'),
        price: $el.data('price'),
        handle: $el.data('handle')
      });
      console.log(config.scope.colors);
      if(!$("#login-msg").is(":visible")){
        $("#was-added").html('<b>' + $el.data('title') + '</b>' + ' was added to Compare Colors');
        $("#added-to-list").fadeIn(200, function(){
          setTimeout(function(){ $("#added-to-list").fadeOut(200) }, 1000);
        });
      };
    }else{
      destroyColor($el);
    };
    saveScopeToDB(false);
  };
  
  var saveSortColors = function(){
    var sort = [];
    $(".cc-color").each(function(){
      var id = $(this).data('id');
      var found = $.grep(config.scope.colors, function(e){ return e.id == id })[0];
      sort.push(found);
    });
    config.scope.colors = sort;
    saveScopeToDB(false);
  };
  
  var observers = function(){
    console.log(2311);
    $('[data-popup]').on('click', function(e){
      e.preventDefault();
      popup($(this));
    });
    $('#rename-list-form').on('submit', function(e){
      e.preventDefault();
      renameList($(this).find("input[name='name']").val());
    });
    document.querySelectorAll(".cc-color")
      .forEach(function(el) {
        el.addEventListener("click",
          function() {
            this.classList.toggle("selected");
          });
      });
    // $(".cc-color img").on("click", function(){
    //   $(this).parents(".cc-color").toggleClass("selected");
    //   return false;
    // });
    $('.cc-delete').on('click', function(e){
      e.preventDefault();
      destroyColor($(this));
    });
    $('body').on('change', '.cc-pick-color > input', function() {
      console.log(123);
      addColorToList($(this));
    });
    $('.cc-add').on('click', function(e){
      e.preventDefault();
      var id = $(this).data('id');
      $.post('/cart/add.json', {id: id, quantity: 1}, function(){
      	location = '/cart';
      });
    });
    $('.cc-close-form-btn').on('click', function(e){
      e.preventDefault();
      $('table#lists').show();
      $('#new-list-form-b').hide();
      $('.cc-col-actions').show();
    });
    Shopify.moveAlong = function(cb){
      if(Shopify.queue.length) {
        var request = Shopify.queue.shift();
        $.post('/cart/add.json', {id: request.id, quantity: 1}, function(){
          // Shopify.moveAlong(cb);
        }).fail(function(res) {
          if(Shopify?.queueErrors == null)
            Shopify.queueErrors = []
          if(res?.statusText === 'error' && res?.responseJSON?.errors) {
            Shopify.queueErrors.push(res?.responseJSON?.errors);
            $('#atc-errors').append(`<p class="error">${res?.responseJSON?.errors}</p>`);
          }
          // 
        }).always(function() {
          Shopify.moveAlong(cb);
        });
      }else{
        if(cb)
          cb();
        if(Shopify?.queueErrors === null)
          document.location.href = '/cart';
        Shopify.queueErrors = null;
      };
    };
    $("#add-all-yarns").click(function(){
      $(this).attr("disabled",true);
      var values = [];
      $(".cc-add").each(function(){
        values.push({id: $(this).data('id')});
      });
      if(values?.length) {
        console.log('loading...........');
        this.classList.add('loading');
      }

      Shopify.queueErrors = null;
      Shopify.queue = values;
      Shopify.moveAlong(function() {
        $("#add-all-yarns").attr("disabled", false);
        $("#add-all-yarns").removeClass('loading');
      });
    });
    $("#del-multiple").click(function(){
      var $els = $(".cc-color.selected");
      destroyMultipleColors($els);
    });
    $("#add-selected").click(function(){
      $(this).attr("disabled",true);
      var values = [];
      $(".cc-color.selected").each(function(){
        values.push({id: $(this).data('id')});
      });
      if(values?.length) {
        console.log('loading...........');
        this.classList.add('loading');
      }
      
      Shopify.queueErrors = null;
      Shopify.queue = values;
      Shopify.moveAlong(function() {
        $("#add-selected").attr("disabled", false);
        $("#add-selected").removeClass('loading');
      });
    });
    $(document).ready(function() {
      console.log("this is working");
      if($(window).width() < 768){
        $('#colors').sortable({
         handle:'.sort-action',
          update: function () {
            saveSortColors();
          }
        });
        $("#colors .mobile-sort").disableSelection();
      }else{
        $('#colors').sortable({
          update: function () {
            saveSortColors();
          }
        });
      }

      $('#colors').disableSelection();
    });
  };

    
  var formSerializeObj = function($form){
    var o = {};
    $form.serializeArray().map(function(e){
      o[e.name] = e.value;
    });
    return o;
  };
    
  var templateEngine = function(html, options) {
    var re = /<%\s([^%>]+)?\s%>/g, 
        reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g, 
        code = 'var r=[];\n', cursor = 0, match;
    var add = function(line, js) {
      js? (code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n') :
          (code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '');
      return add;
    };
    while(match = re.exec(html)) {
      add(html.slice(cursor, match.index))(match[1], true);
      cursor = match.index + match[0].length;
    };
    add(html.substr(cursor, html.length - cursor));
    code += 'return r.join("");';
    return new Function(code.replace(/[\r\t\n]/g, '')).apply(options);
  };

  var objToStr = function(obj){
    var str = [];
    for (var k in obj) {
      obj[k] = obj[k] == null ? '' : obj[k];
      str.push(k + '=' + obj[k]);
    };
    return str.join('&');
  };

  var paramsToObj = function(str){
    return JSON.parse('{"' + decodeURI(str.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}');
  };
      
  return {
    init: function(options){
      console.log(5554);
      $.extend(config, options);
      if(config.customer != false){ // user logged in
        console.log(555114);
        initDB(function(){
          loadSetup();
          if(location.pathname != '/pages/compare-colors')
            loadColSetup();
          observers();
        });
      }else{
        console.log(555114);

        initDB();
        loadSetup();
        if(location.pathname != '/pages/compare-colors')
          loadColSetup();
        observers();
      };
    },
    
    log: function(){
      return config;
    }
  };
}());

  var is_customer = document.querySelector('body').getAttribute("data-customer")
  console.log(is_customer);
  if(is_customer == "false"){
    is_customer = false;
  }
  ColorCompare.init({
    customer: is_customer
});
});
console.log(Cookies.get('cc_db'));
